(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/race-history-extended-item.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/race-history-extended-item.js');

'use strict';

const {
  getCurrencyType,
  getKilometerTime
} = svs.racing.common.strings;
const ButtonBet = svs.ui.ReactButtonBet;
const {
  parseFinishPlaceReason
} = svs.racing.raceService.utils.parse;
const {
  getResultText
} = svs.racing.common.strings;
const RaceHistoryExtendedItem = _ref => {
  let {
    participant
  } = _ref;
  return React.createElement("div", {
    className: "race-history-row extended fc-navy"
  }, React.createElement("div", {
    className: "horse-history-column drop-down fc-racing-900"
  }, React.createElement(ButtonBet, {
    branding: "racing",
    className: "btn-bet-result",
    label: getResultText(participant.result.finishPlace, parseFinishPlaceReason(participant.result.finishPlaceReason), participant.result.finishPlaceReason === 'NonRunner'),
    size: "300"
  })), React.createElement("div", {
    className: "horse-history-column horse-info"
  }, React.createElement("div", {
    className: "driver-name"
  }, participant.horseName), React.createElement("div", {
    className: "driver-name fc-racing-900"
  }, participant.driverName)), participant.trotting ? React.createElement("div", {
    className: "horse-history-column kilometer-time"
  }, getKilometerTime(participant.trotting.kilometerTime)) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "horse-history-column distance-to-winner"
  }, participant.gallop.distancePrevious || '-'), React.createElement("div", {
    className: "horse-history-column start-gate"
  }, participant.gallop.startGate && participant.gallop.startGate > 0 ? participant.gallop.startGate : '-'), React.createElement("div", {
    className: "horse-history-column riders-weight"
  }, participant.gallop.driverTotalWeight)), React.createElement("div", {
    className: "horse-history-column prize-money"
  }, "".concat(svs.utils.format.Currency(participant.earnings), " ").concat(getCurrencyType(participant.currency))), React.createElement("div", {
    className: "horse-history-column finish-place"
  }), React.createElement("div", {
    className: "horse-history-column race-distance"
  }), React.createElement("div", {
    className: "horse-history-column race-dicipline"
  }));
};
svs.racing_game.components.statistics.RaceHistoryExtendedItem = RaceHistoryExtendedItem;

 })(window);